import { useState } from "react";
import { Package, Pencil, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import TopicDialog from "@/components/autopilot/TopicDialog";
import { imageUrl } from "@/lib/api";

export default function TopicList({ cfg, save }) {
  const [editing, setEditing] = useState(null);
  const topics = cfg.topics;
  const nextIdx = topics.length ? cfg.topic_cursor % topics.length : -1;

  const persist = async (list, msg) => (await save({ topics: list }, msg)) && setEditing(null);
  const onSave = (t) => persist(t.id ? topics.map((x) => (x.id === t.id ? t : x)) : [...topics, t], "Topik disimpan");
  const remove = (t) => window.confirm(`Padam topik "${t.title}"?`) && persist(topics.filter((x) => x.id !== t.id), "Topik dipadam");

  return (
    <section className="panel fade-up p-6" data-testid="autopilot-topics-card">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-bold"><Package className="h-4 w-4 text-primary" /> Topik & produk</h2>
        <Button size="sm" onClick={() => setEditing({})} data-testid="autopilot-add-topic-btn"><Plus className="mr-1.5 h-4 w-4" />Tambah</Button>
      </div>
      <p className="mt-1 text-xs text-muted-foreground">Satu topik digunakan setiap hari, bergilir-gilir.</p>
      {!topics.length && <p className="mt-6 rounded-lg border border-dashed border-border p-6 text-center text-sm text-muted-foreground" data-testid="autopilot-topics-empty">Belum ada topik. Tambah produk atau perkara yang anda mahu AI promosikan.</p>}
      <div className="mt-4 space-y-3" data-testid="autopilot-topics-list">
        {topics.map((t, i) => (
          <div key={t.id} className="flex items-start gap-3 rounded-lg border border-border p-3" data-testid={`autopilot-topic-${t.id}`}>
            {t.image_id && <img src={imageUrl(t.image_id)} alt="" className="h-11 w-11 rounded-md border border-border object-cover" />}
            <div className="min-w-0 flex-1">
              <p className="flex items-center gap-2 truncate text-sm font-semibold">{t.title}
                {i === nextIdx && <span className="rounded bg-emerald-500/15 px-1.5 py-0.5 text-[10px] font-medium text-emerald-300" data-testid={`autopilot-topic-next-${t.id}`}>Seterusnya</span>}
              </p>
              <p className="mt-0.5 line-clamp-2 text-xs text-muted-foreground">{t.details}</p>
            </div>
            <Button size="icon" variant="ghost" className="h-8 w-8" onClick={() => setEditing(t)} data-testid={`autopilot-topic-edit-${t.id}`}><Pencil className="h-3.5 w-3.5" /></Button>
            <Button size="icon" variant="ghost" className="h-8 w-8 text-red-300" onClick={() => remove(t)} data-testid={`autopilot-topic-delete-${t.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
          </div>
        ))}
      </div>
      <TopicDialog topic={editing} onClose={() => setEditing(null)} onSave={onSave} />
    </section>
  );
}
